import {forwardRef, InputHTMLAttributes} from 'react';
import {generateRandomString, join} from '../../utils';
import {Selectors} from '../controls.selectors';
import styles from './input.module.less';

type PossibleInputType = 'email' | 'password' | 'tel' | 'text' | 'number';

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'checked' | 'type'> & { type?: PossibleInputType };

function generateID(): string {
	return 'text_input_' + generateRandomString(5);
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({className, children, ...props}, ref) =>
	<input id={generateID()}
	       data-cy={Selectors.Input}
	       {...props}
	       autoComplete='off'
	       data-lpignore={'true'}
	       ref={ref}
	       className={join(styles.input, className)}/>
);

export default Input;
